import { useNavigate } from 'react-router-dom';
import { ImgPlaceholder } from '../components/ImgPlaceholder';
import { StateMessage } from '../components/StateMessage';
import { useFormateurs } from '../data/queries';
import { useSEO } from '../hooks/useSEO';
import type { FormateurCouleur, Tone } from '../types';

const FORMATEUR_TONE: Record<FormateurCouleur, Tone> = {
  vert: 'vert',
  rouge: 'rouge',
  or: 'creme',
};

export function FormateursList() {
  const navigate = useNavigate();
  const formateursQ = useFormateurs();

  useSEO({
    title: 'Nos formateurs',
    description:
      'Comité scientifique MTC : chirurgiens-dentistes reconnus en implantologie, orthodontie, endodontie, parodontologie, esthétique.',
  });

  if (formateursQ.isLoading) return <StateMessage variant="loading" />;
  if (formateursQ.error) return <StateMessage variant="error" message={String(formateursQ.error)} />;
  const formateurs = formateursQ.data ?? [];

  return (
    <div className="page-formateurs">
      <div className="cat-head">
        <span className="mtc-eyebrow">Comité scientifique</span>
        <h1>Nos formateurs</h1>
        <p>
          Des praticiens reconnus pour leur expertise clinique et leur capacité à transmettre.
        </p>
      </div>
      <div className="ap-team-grid">
        {formateurs.map((fo) => (
          <button
            key={fo.id}
            type="button"
            className="ap-formateur"
            onClick={() => navigate(`/formateurs/${fo.id}`)}
          >
            <ImgPlaceholder
              label={fo.nom.split(' ').slice(-1)[0] ?? fo.nom}
              ratio="3/4"
              tone={FORMATEUR_TONE[fo.couleur]}
              src={fo.photo}
              alt={fo.nom}
            />
            <div className="ap-formateur-body">
              <h4>{fo.nom}</h4>
              <p>{fo.titre}</p>
              <span className="ap-formateur-link">Voir le profil →</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
